import {Toast} from 'mint-ui';
import fetch from '@/common/util/fetch';

let urls = {
    getProvincial: '/insightH5/remote/userCenter/city',
    getGrade: '/insightH5/h5/gradeList'
};

let actions = {
    getProvincialInfo(context) {
        return fetch({
            'url': urls.getProvincial
        }).then((res)=>{
            let result = res.data ? res.data : {};
            // data 判断
            if (result.error_code == 0) {
                context.commit('provinceInfo', result.data);
            } else {
                Toast(result.error_msg || '省市配置信息获取失败！')
            }
            return result;
        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    },
    getGradeInfo(context) {
        return fetch({
            'url': urls.getGrade
        }).then((res) => {
            let result = res.data ? res.data : {};
            if (result.error_code == 0) {
                context.commit('gradeInfo', result.data);
            } else {
                Toast(result.error_msg || '年级信息获取失败')
            }
            return result;
        }).catch((error) => {
            Toast('页面暂时无法访问，请稍后重试！');
        });
    }
}
export default actions;


// WEBPACK FOOTER //
// ./src/vuex/modules/provincialGrade/actions.js